import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {IconDefinition} from '@fortawesome/fontawesome-svg-core';
import {FaIconComponent} from '@fortawesome/angular-fontawesome';

/**
 * Einheitlicher Leerzustand ("Empty State") für alle Haupt-Views.
 * Vorbild ist die Darstellung im myCheck-Overview: Icon + kurzer Text + optionaler CTA,
 * jedoch vertikal & horizontal im View zentriert.
 *
 * Der optionale CTA-Button wird per Content-Projection übergeben, damit jede View
 * ihren eigenen Button samt Klick-Handler behält:
 *
 *   <app-empty-state [icon]="faCube" message="Keine Checks gefunden.">
 *     <bic-button (onClick)="createNewCheck()" buttonType="white">Neuer Check</bic-button>
 *   </app-empty-state>
 *
 * Hinweis zur Zentrierung: Die Komponente füllt ihren Eltern-Container (h-full w-full).
 * Der umschließende Container der View muss dem Kind daher Höhe geben (flex-1 / h-full).
 */
@Component({
  selector: 'app-empty-state',
  standalone: true,
  imports: [FaIconComponent],
  templateUrl: './empty-state.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./empty-state.component.scss'],
})
export class EmptyStateComponent {
  /** FontAwesome-Icon oberhalb des Textes. */
  @Input({required: true}) icon!: IconDefinition;

  /** Kurzer Text, der den Leerzustand beschreibt (z. B. "Keine Checks gefunden."). */
  @Input({required: true}) message = '';
}
